module.exports = __webpack_public_path__ + "img/logo.e68c1132.png";